module.exports = __webpack_public_path__ + "static/media/Gilroy-Thin-Italic.b458f57f.woff";